import React from 'react';

import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';

import { getConfig, getThemeName } from '../../features/config/selectors';

const { themes } = require('@ps-int/general-themes/themes');

export const ThemeBackground = () => {
    const themeName = useSelector(getThemeName);
    const { nonce } = useSelector(getConfig);

    if (!themeName || !themes[themeName]) {
        return null;
    }

    const {
        page: { override, orbOverride },
    } = themes[themeName];

    const color = orbOverride?.['--bg-color'] || override['--bg-color'];

    return (
        <Helmet>
            <style nonce={nonce}>{`body { background-color: rgb(${color})!important; } `}</style>
        </Helmet>
    );
};
